import { gql } from '@apollo/client';

export const CREATE_AI_HOMEWORK_GROUP = gql`
  mutation createAIHomeworkGroup($folder_type: String, $type: String, $data: String) {
    createAIHomeworkGroup(folder_type: $folder_type, type: $type, data: $data) {
      idx
      group_name
      user_idx
      campus_idx
      company_idx
    }
  }
`;

export const UPDATE_AI_HOMEWORK_GROUP = gql`
  mutation updateAIHomeworkGroup($idx: Int!, $folder_type: String, $type: String, $data: String) {
    updateAIHomeworkGroup(idx: $idx, folder_type: $folder_type, type: $type, data: $data) {
      idx
      group_name
      user_idx
      campus_idx
      company_idx
    }
  }
`;

export const DELETE_AI_HOMEWORK_GROUP = gql`
  mutation deleteAIHomeworkGroup($idx: Int!) {
    deleteAIHomeworkGroup(idx: $idx)
  }
`;

export const DELETE_AI_HOMEWORK_ASSIGNMENT_GROUP = gql`
  mutation deleteAIHomeworkAssignmentGroup($idx: Int!) {
    deleteAIHomeworkAssignmentGroup(idx: $idx)
  }
`;


export const CREATE_AI_HOMEWORK = gql`
  mutation createAIHomework($input: AIHomeworkInput!) {
    createAIHomework(input: $input) {
      idx
      title
    }
  }
`;

export const UPDATE_AI_HOMEWORK = gql`
  mutation updateAIHomework($idx: Int!, $input: AIHomeworkInput!) {
    updateAIHomework(idx: $idx, input: $input) {
      idx
      title
    }
  }
`;

export const DELETE_AI_HOMEWORK = gql`
  mutation deleteAIHomework($idxs: [Int!]!) {
    deleteAIHomework(idxs: $idxs)
  }
`;

export const ASSIGN_AI_HOMEWORK_TO_STUDENTS = gql`
  mutation assignAIHomeworkToStudents($input: AIHomeworkAssignInput!) {
    assignAIHomeworkToStudents(input: $input)
  }
`;

export const EDIT_AI_HOMEWORK_ASSIGNMENT_TO_STUDENTS = gql`
  mutation assignAIHomeworkToStudents(
    $class_idx: Int
    $start_time: [String!]!
    $limit_time: Int!
    $user_idx_list: [Int!]!
    $external_data: [JSONObject!]!
    $start_date: String!
    $end_date: String!
    $study_time: String!
    $rowidx: Int
    $type: String
    $data: String
    $title: String
    $addStudentToOldStudy: Boolean
  ) {
    assignAIHomeworkToStudents(
      class_idx: $class_idx
      start_time: $start_time
      limit_time: $limit_time
      user_idx_list: $user_idx_list
      external_data: $external_data
      start_date: $start_date
      end_date: $end_date
      study_time: $study_time
      rowidx: $rowidx
      type: $type
      data: $data
      title: $title
      addStudentToOldStudy: $addStudentToOldStudy
    )
  }
`;

export const SUBMIT_AI_HOMEWORK_PHOTOS = gql`
  mutation submitAIHomeworkPhotos($assignment_idx: Int!, $photos: [AIHomeworkPhotoInput!]!) {
    submitAIHomeworkPhotos(assignment_idx: $assignment_idx, photos: $photos) {
      idx
      status
      start_time
      end_time
      answer_image_url_json
    }
  }
`;

export const START_AI_HOMEWORK_ASSIGNMENT = gql`
  mutation startAIHomeworkAssignment($assignment_idx: Int!) {
    startAIHomeworkAssignment(assignment_idx: $assignment_idx) {
      idx
      status
      start_time
      end_time
    }
  }
`;

export const EVALUATE_AI_HOMEWORK_ASSIGNMENT = gql`
  mutation evaluateAIHomeworkAssignment($assignment_idx: Int!) {
    evaluateAIHomeworkAssignment(assignment_idx: $assignment_idx) {
      idx
      assignment_idx
      status
      total_score
      max_score
      image_urls
      grading_result_json
      grading_error_message
      error_message
      graded_at
    }
  }
`;

export const REVIEW_AI_HOMEWORK_ASSIGNMENT = gql`
  mutation reviewAIHomeworkAssignment($assignment_idx: Int!, $teacher_review_json: String!) {
    reviewAIHomeworkAssignment(assignment_idx: $assignment_idx, teacher_review_json: $teacher_review_json) {
      idx
      answer
      result_data
      teacher_review_json
      answer_image_url_json
      score
      status
    }
  }
`;

export const GRADE_HOMEWORK_SUBMISSION_PREVIEW = gql`
  mutation gradeHomeworkSubmissionPreview(
    $answerKeyImageUrls: [String!]!
    $studentImageUrls: [String!]!
    $answerRubric: String
    $model: String
  ) {
    gradeHomeworkSubmissionPreview(
      answerKeyImageUrls: $answerKeyImageUrls
      studentImageUrls: $studentImageUrls
      answerRubric: $answerRubric
      model: $model
    )
  }
`;

export const EXTRACT_AI_HOMEWORK_QUESTIONS = gql`
  mutation extractAIHomeworkQuestions($imageUrls: [String!]!, $model: String) {
    extractAIHomeworkQuestions(imageUrls: $imageUrls, model: $model)
  }
`;

export const ASSIGN_AI_HOMEWORK_GROUP_TO_STUDENTS = gql`
  mutation assignAIHomeworkGroupToStudents(
    $class_idx: Int
    $start_time: [String!]!
    $limit_time: Int!
    $user_idx_list: [Int!]!
    $external_data: [JSONObject!]!
    $start_date: String!
    $end_date: String!
    $study_time: String!
    $rowidx: Int
    $type: String
    $data: String
    $title: String
    $addStudentToOldStudy: Boolean
  ) {
    assignAIHomeworkGroupToStudents(
      class_idx: $class_idx
      start_time: $start_time
      limit_time: $limit_time
      user_idx_list: $user_idx_list
      external_data: $external_data
      start_date: $start_date
      end_date: $end_date
      study_time: $study_time
      rowidx: $rowidx
      type: $type
      data: $data
      title: $title
      addStudentToOldStudy: $addStudentToOldStudy
    )
  }
`;
